import {BaseInterface} from './BaseInterface';

export class Unauthorized {

    private errors: BaseInterface[] = null;

    // ########################################

    constructor(
        errors: BaseInterface[]
    ) {
        this.errors = errors;
    }

    // ########################################

    public getErrors(): BaseInterface[] {
        return this.errors;
    }

    // ########################################
}
